import React from "react";
import './productstyle.css';
export default function Products()
{
    return(
      <div className="pro" id="products">
        <div className="container" >
        <h3 className="title"> Our Products </h3>
        <div className="products-container">
          <div className="product" data-name="p-1">
            <img src="./1.png" alt="" />
            <h3>Chai</h3>
            <div className="price">Rs.15.00</div>
          </div>
          <div className="product" data-name="p-2">
            <img src="./2.png" alt="" />
            <h3>Coffee</h3>
            <div className="price">Rs.30.00</div>
          </div>
          <div className="product" data-name="p-3">
            <img src="./3.png" alt="" />
            <h3>Kullad Chai</h3>
            <div className="price">Rs.30.00</div>
          </div>
          <div className="product" data-name="p-4">
            <img src="./4.png" className="img4" alt="" width={'350px'}/>
            <h3>Green Tea</h3>
            <div className="price">Rs.40.00</div>
          </div>
          <div className="product" data-name="p-5">
            <img src="./5.png" alt="" />
            <h3>Special Masala Chai</h3>
            <div className="price">Rs.40.00</div>
          </div>
          <div className="product" data-name="p-6">
            <img src="./6.png" alt="" />
            <h3>Cold Coffee</h3>
            <div className="price">Rs.70.00</div>
          </div>
        </div>
      </div>
    </div>

    );
}